import { Injectable, Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { IcsToastService } from '@varmasagi/ics-toast';
import { IcsDialogService } from '@varmasagi/ics-dialog';
import { IcsDriveService } from '../ics-drive.service';

@Component({
  selector: 'lib-app-image-popup',
  template: `<div class="dailog__container">
  <div class="row background__white">
    <p class=" col-md-9 dailog__container--heading">
      File: {{currImgName}}
    </p>
    <div class="col-md-3">
      <a href="{{currImgLoc}}" download target="_blank">
        <button class="downloadDailog pad-z">
          <img src="{{ imgBaseUrl }}download_icon.svg" class="img--close_icon" alt="">
        </button>
      </a>
      <button (click)="delete()" class="img-responsive pad-z " mat-button>
        <img src="{{ imgBaseUrl }}remove_icon.svg" class=" del img--close_icon" alt="">
      </button>
      <button class="closeDailog pad-z" mat-button [mat-dialog-close]="true">
        <img src="{{ imgBaseUrl }}close.svg" class="img--close_icon" alt="">
      </button>
    </div>
  </div>


  <div class="viewBox--container">
    <div *ngIf="!currImgName" class="loader">
      <img src="https://s3-us-west-2.amazonaws.com/repository-leadics-test/leap/leap_icons/loader_leap.gif" alt="">
      <p class="text-muted text-center">loading</p>
    </div>
    <img src="{{currImgLoc}}" *ngIf="filetypeimage" alt="{{currImgName}}" class="img-responsive viewBoxImg" />
    <div class="viewBox--container--file" *ngIf="!filetypeimage && currImgName">
      <img src="{{ imgBaseUrl }}file_icon.svg" alt="{{currImgName}}" class="img-responsive viewBoxImg--custom--img" />
      <a href="{{currImgLoc}}" download target="_blank">
        <button class="downloadDailog--filetype">
          Download
        </button>
      </a>

      <p class=" marginTop25 small--font text-center color--primary">
        <b>{{currImgName}}</b>
      </p>
    </div>

  </div>

  <div class="scrolling-wrapper-flexbox" *ngIf="thumbShow">
    <div class="thumb t--card" *ngFor="let image of responseFiles" [ngClass]="{'active':image.location === currImgLoc}" (click)=showThisthumb(image.location,image.name,image.id)>
      <img src="{{image.location}}" alt="{{image.name}}" class="img-responsive" />
    </div>
  </div>
</div>`,
  styles: [`.color--primary{color:#3a134d}.small--font{font-size:.8em}.text__uppercase{text-transform:uppercase;font-family:Raleway,sans-serif!important}.dailog__container{padding:1px 15px;background:#eaf0f4;position:relative}.dailog__container .background__white{background:#fff}.dailog__container--heading{padding:10px;font-weight:600;font-size:1em;margin:0}.dailog__container .downloadDailog{background:0 0;border:none}.dailog__container .downloadDailog .img--close_icon{width:15px!important;height:15px!important}.dailog__container figure{margin:15px 0}.dailog__container figure figcaption{font-size:14px;margin:10px 0}.dailog__container .mat-button-focus-overlay{background:rgba(0,0,0,0)!important}.dailog__container mat-tab-body{background:#fff!important;box-shadow:0 0!important}.dailog__container .uploadContainer .file__name{font-family:Raleway,sans-serif!important;font-weight:400;font-size:14px}.dailog__container .uploadContainer__uploadFileList mat-list.mat-list{max-height:23vh!important;overflow-y:auto}.dailog__container .uploadContainer__uploadFileList .file__name.mat-line{font-family:Raleway,sans-serif!important;font-weight:400;font-size:14px}.dailog__container .uploadContainer__uploadFileList .mat-list .mat-list-item{display:block;height:23px!important}.dailog__container .uploadContainer__uploadFileList .mat-dialog-actions{padding:12px 0;margin-bottom:0!important}.dailog__container .uploadContainer__drangDrop{padding:20px;margin:10px;background:#fff;line-height:1.3em;border:2px dashed #c2b7c8;border-radius:10px;box-shadow:0 0 0 4px #fff,2px 1px 6px 4px #fff;text-shadow:-1px -1px #fff;font-weight:400}.dailog__container .uploadContainer__drangDrop--label{color:rgba(58,19,77,.5);font-size:14px;font-family:Raleway,sans-serif!important;margin-bottom:6px;font-weight:600}.dailog__container .uploadContainer--heading{color:#3a134d;font-size:16px;font-weight:600;margin-bottom:0}.dailog__container .uploadContainer--heading.heading__label{color:#169696!important;margin:0;padding:0!important;font-size:20px}.dailog__container .uploadButton{background:#65ceee;color:#fff;font-family:Raleway,sans-serif;font-weight:600;border:none;border-radius:4px;margin:0 auto;display:block;padding:5px 13px}.dailog__container .closeDailog{position:absolute;top:2px;right:5px;background:0 0;border:0;z-index:9999;cursor:pointer}.dailog__container .img--dragdrop_icon{width:50px;height:50px;margin:0 auto 15px;display:block}.dailog__container .img--dragdrop_icon.leapdriveIcon{height:auto!important;width:227px!important;margin-top:50px}.dailog__container .img--close_icon{width:10px;height:10px}.dailog__container .img--close_icon.del{width:15px;height:15px}.dailog__container .scrolling-wrapper-flexbox{display:flex;flex-wrap:nowrap;overflow-x:auto;margin:10px 0}.dailog__container .scrolling-wrapper-flexbox.single-center{justify-content:center}.dailog__container .scrolling-wrapper-flexbox .thumb{width:10vw;margin:5px 7.5px;cursor:pointer}.dailog__container .scrolling-wrapper-flexbox .thumb.t--card{flex:0 0 auto;opacity:.5}.dailog__container .scrolling-wrapper-flexbox .thumb.t--card.active{opacity:1!important}@media (min-width:768px){.offset-md-3{margin-left:25%!important}}.viewBox--container{min-height:25vw;max-height:30vw}.viewBox--container .viewBoxImg{width:90%;margin:10px 5% 0}.viewBox--container .downloadDailog--filetype .img--close_icon{width:100px;height:100px}.viewBox--container .viewBoxImg--custom--img{width:100px;height:100px;display:block;margin:0 auto}.viewBox--container--file{margin-top:50px}.viewBox--container--file .downloadDailog--filetype{background:#5e2b77;border:0;color:#fff;font-family:Oswald,sans-serif;padding:7px 20px;text-transform:uppercase;border-radius:4px;margin:19px auto 0;display:block;cursor:pointer}.pad-z{padding:0!important}`],
  providers: [IcsDriveService]
})
@Injectable()
export class ImagePopupComponent implements OnInit {
  imgBaseUrl =
    'https://s3-us-west-2.amazonaws.com/repository-leadics-test/leap/leap_icons/uploadRepo/';
  imageID: string;
  public fileId: string;
  public fileLocation: any;
  public responseFiles: any;
  public imageDesc: any;
  public currImgLoc: string;
  public currImgName: string;
  public currImgId: number;
  public thumbShow = true;
  public filetypeimage: any;
  constructor(
    public dialogRef: MatDialogRef<ImagePopupComponent>,
    private icsDialogService: IcsDialogService,
    public uploadService: IcsDriveService,
    private toastService: IcsToastService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  delete() {
    this.icsDialogService
      .confirm({
        title: 'Delete',
        message:
          'This file might be used in other Applications. Are you sure you want to delete it?'
      })
      .subscribe(flag => {
        if (flag) {
          this.uploadService.delete(this.currImgId).subscribe(
            (res: any[]) => {
              this.toastService.success('Deleted!');
              this.dialogRef.close(this.currImgId);
              return this.currImgId;
            },
            err => {
              this.toastService.error('This file doesnot exist!');
            }
          );
        }
      });
  }

  ngOnInit() {
    this.imageID = this.data.name;
    this.uploadService.getFilesLists(this.imageID).subscribe(
      (res: any[]) => {
        this.responseFiles = res;
        if (this.responseFiles.length === 1) {
          this.thumbShow = false;
        } else {
          this.thumbShow = true;
        }
        this.imageDesc = res[0];
        this.currImgLoc = this.imageDesc.location;
        this.currImgName = this.imageDesc.name;
        this.getFileExt(this.currImgName);
        this.currImgId = this.imageDesc.id;
      },
      err => {
        return err;
      }
    );
  }

  showThisthumb(fileLoc, fileName, fileid) {
    this.currImgLoc = fileLoc;
    this.currImgName = fileName;
    this.currImgId = fileid;
  }

  getFileExt(args: string) {
    const key = args.lastIndexOf('.');
    const value = args.substring(key, args.length);
    if (
      value === '.png' ||
      value === '.jpg' ||
      value === '.jpeg' ||
      value === '.svg'
    ) {
      this.filetypeimage = true;
    } else {
      this.filetypeimage = false;
    }
  }
}
